










import { Component, Vue, Prop } from 'vue-property-decorator'
import router from '@/router'

@Component({
})
export default class AppAeroguestComponent extends Vue {
  public async mounted () {
    this.timeout()
  }

  // Timeout to make it seem less "aggressive".
  public timeout () {
    setTimeout(this.checkOS, 1500)
  }

  public checkOS () {
    const language = window.navigator.language
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      window.location.href = 'https://play.google.com/store/apps/details?id=ag.app.android'
    } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
      window.location.href = `https://apps.apple.com/dk/app/aeroguest/id1164025815?l=${language || 'en'}`
    } else {
      window.location.href = 'https://join.aeroguest.com'
    }
  }
}
